
import { OrgHomeScreenProps } from "../OrgHomeNavigation";
import { WorkspaceAnalyticsStack } from "./WorkspaceAnalyticsStack";
import { WorkspaceAnalyticsMainScreen } from "./WorkspaceAnalyticsMain";
import { WorkspaceAnalyticsDetailScreen } from "./WorkspaceAnalyticsDetail";
import { WorkspaceAnalyticsSinglePeriodDetailScreen } from "./WorkspaceAnalyticsSinglePeriodDetail";
import { WorkspaceDataTodoMainScreen } from "./WorkspaceDataTodo";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { WorkspaceAnalyticsTab } from "./WorkspaceAnalyticsNavigation";
import { useIntl } from "react-intl";
function WorkspaceAnalyticsTabNavigator() {
  const intl_tokens = useIntlTokens();
  const intl = useIntl();

  return (
    <WorkspaceAnalyticsTab.Navigator
      screenOptions={{
        headerShown: false,
      }}
      title={intl_tokens.Analytics}
    >
      <WorkspaceAnalyticsTab.Screen
        name="WorkspaceAnalyticsMain"
        component={WorkspaceAnalyticsMainScreen}
        options={{
          headerShown: false,
          title: intl.formatMessage({
            defaultMessage: "Overview",
            description: "WorkspaceAnalyticsTab Navigator Overview",
          }),
        }}
      />
      <WorkspaceAnalyticsTab.Screen
        name="WorkspaceDataTodoMain"
        component={WorkspaceDataTodoMainScreen}
        options={{
          headerShown: false,
          title: intl.formatMessage({
            defaultMessage: "Issue Search (beta)",
            description: "WorkspaceAnalyticsTab Navigator Issue Search",
          }),
        }}
      />
    </WorkspaceAnalyticsTab.Navigator>
  );
}

export function WorkspaceAnalyticsScreen(
  props: OrgHomeScreenProps<"WorkspaceAnalytics">
) {
  return (
    <WorkspaceAnalyticsStack.Navigator screenOptions={{}}>
      <WorkspaceAnalyticsStack.Screen
        name="WorkspaceAnalyticsTabs"
        component={WorkspaceAnalyticsTabNavigator}
        options={{
          headerShown: false,
        }}
      />
      <WorkspaceAnalyticsStack.Screen
        name="WorkspaceAnalyticsDetail"
        component={WorkspaceAnalyticsDetailScreen}
        options={{
          headerShown: false,
          headerBackButtonDisplayMode: "default",
          title: "",
        }}
      />
      <WorkspaceAnalyticsStack.Screen
        name="WorkspaceAnalyticsSinglePeriodDetail"
        component={WorkspaceAnalyticsSinglePeriodDetailScreen}
        options={{
          headerShown: false,
          headerBackButtonDisplayMode: "default",
          title: "",
        }}
      />
    </WorkspaceAnalyticsStack.Navigator>
  );
}
